import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';

class ProductTypes {
  static list: IActionType = new ActionType('PRODUCT/LIST');
  static listMine: IActionType = new ActionType('PRODUCT/MY_LIST');
  static listVariations: IActionType = new ActionType('PRODUCT/LIST_VARIATION');
  static coProducers: IActionType = new ActionType('PRODUCT/CO_PRODUCERS');
  static new: IActionType = new ActionType('PRODUCT/NEW');
  static edit: IActionType = new ActionType('PRODUCT/EDIT');
  static categories: IActionType = new ActionType('PRODUCT/CATEGORIES');
  static product: IActionType = new ActionType('PRODUCT/PRODUCT');
  static productBadges: IActionType = new ActionType('PRODUCT/BADGES');
  static productInvoice: IActionType = new ActionType('PRODUCT/INVOICE');
  static affiliatesProductStatusSummary: IActionType = new ActionType('PRODUCT/AFFILIATESPRODUCTSTATUSSUMARY');
  static productStatus: IActionType = new ActionType('PRODUCT/STATUS');
  static productInviteAffiliate: IActionType = new ActionType('PRODUCT/INVITE_AFFILIATES');
  static productDelivery: IActionType = new ActionType('PRODUCT/DELIVERY');
  static cloneProductById: IActionType = new ActionType('PRODUCT/CLONE_BY_ID');
  static deliveryMethods: IActionType = new ActionType('PRODUCT/DELIVERY_METHODS');
  static file: IActionType = new ActionType('PRODUCT/FILE');
  static newCoproducer: IActionType = new ActionType('PRODUCT/NEW_CO_PRODUCER');
  static listProductsChildren: IActionType = new ActionType('PRODUCT/LIST_CHILDREN');
  static productCampaigns: IActionType = new ActionType('PRODUCT/CAMPAIGNS');
  static enableMelhorEnvioAuth: IActionType = new ActionType('PRODUCT/ENABLE_MELHOR_ENVIO_AUTH');
  static getDeliveryIntegrationActiveList: IActionType = new ActionType('PRODUCT/GET_DELIVERY_INTEGRATIONS');
  static editProductCampaign: IActionType = new ActionType('PRODUCT/EDIT_CAMPAIGN');
  static createProductCampaign: IActionType = new ActionType('PRODUCT/CREATE_CAMPAIGN');
  static updatePostback: IActionType = new ActionType('PRODUCT/UPDATE_POSTBACK');
  static listPostback: IActionType = new ActionType('PRODUCT/LIST_POSTBACK');
  static createProductCampaignTracker: IActionType = new ActionType('PRODUCT/CREATE_CAMPAIGN_TRACKER');
  static loadProductCampaignTracker: IActionType = new ActionType('PRODUCT/LOAD_CAMPAIGN_TRACKER');
  static verifyDomain: IActionType = new ActionType('PRODUCT/VERIFY_DOMAIN');
  static listCoupons: IActionType = new ActionType('PRODUCT/LIST_COUPON');
  static excludeCoupon: IActionType = new ActionType('PRODUCT/EXCLUDE_COUPON');
  static createCoupons: IActionType = new ActionType('PRODUCT/CREATE_COUPON');
  static listCoProductions: IActionType = new ActionType('PRODUCT/LIST_CO_PRODUCTION');
  static listAffiliations: IActionType = new ActionType('PRODUCT/LIST_AFFILIATE');
  static inviteAffiliations: IActionType = new ActionType('PRODUCT/AFFILIATE');
  static cancelAffilation: IActionType = new ActionType('PRODUCT/CANCEL_AFFILIATION');
  static listRecoveryMessages: IActionType = new ActionType('PRODUCT/LIST_RECOVERY_MESSAGE');
  static updateRecoveryMessages: IActionType = new ActionType('PRODUCT/UPDATE_RECOVERY_MESSAGE');
  static createRecoveryMessages: IActionType = new ActionType('PRODUCT/CREATE_RECOVERY_MESSAGE');
  static deleteProductCampaignTracker: IActionType = new ActionType('PRODUCT/DELETE_PRODUCT_CAMPAIGN_TRACKER');
  static listCouponsBatch: IActionType = new ActionType('PRODUCT/LIST_COUPON_BATCH');
  static exportCouponsBatch: IActionType = new ActionType('PRODUCT/EXPORT');
  static createCouponBatch: IActionType = new ActionType('PRODUCT/UPLOAD_FILE');
  static inactivateBatch: IActionType = new ActionType('PRODUCT/INACTIVATE_BATCH');
  static listProductsCampaignFilter: IActionType = new ActionType('PRODUCT/PRODUCT_CAMPAIGN_FILTER');
  static currentProduct: IActionType = new ActionType('PRODUCT/LOAD_PRODUCT_EDIT');
  static saveGeneralBasic: IActionType = new ActionType('PRODUCT/SAVE_GENERAL_BASIC');
  static saveGeneralDetails: IActionType = new ActionType('PRODUCT/SAVE_GENERAL_DETAILS');
  static saveGeneralSupportRefund: IActionType = new ActionType('PRODUCT/SAVE_GENERAL_SUPPORT_REFUND');
}
export default ProductTypes;
